export default __webpack_public_path__ + "static/media/projectShow_color.51bf9ddb.svg";